module.exports = __webpack_public_path__ + "img/chinesecompany50.74511e69.png";